import { MESSAGES } from '@guuru/chat-common';
import { appendLocalMessage, ChatAPI } from '@guuru/chat-web';
import events from '@guuru/events-web';

const createIntroWelcome = (message) =>
  ChatAPI.messages.createBotMessage(
    Date.now(),
    message,
    MESSAGES.welcome,
    {},
    true,
    false,
  );

export default {
  validate() {
    return true;
  },

  render(partnerId, { welcomeMessage }) {
    events.welcome();
    const message = welcomeMessage || createIntroWelcome('bot:::welcome');
    ChatAPI.pushPendingMessages(message);
    appendLocalMessage(message);
    return { goToNextStep: true };
  },
};
